import { useTranslation } from 'react-i18next'

import { refundMethods, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DescriptionMessage = ({ refundMethodType }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      {refundMethodType === refundMethods.bankTransfer && (
        <>
          <Text type="bodyMRegular">
            {t(
              'Cuando los clientes elijan este método de reembolso se les enviará una transferencia bancaria instantánea en el momento que hagan su solicitud.'
            )}
          </Text>
          <Text type="bodyMRegular">{t('Este método solo está disponible para reembolsos instantáneos.')}</Text>
        </>
      )}
      {refundMethodType === refundMethods.storeCredit && (
        <>
          <Text type="bodyMRegular">
            {t(
              'Cuando los clientes elijan este método de reembolso se generará un código de descuento que se les enviará por email en el momento de la emisión.'
            )}
          </Text>
          <Text type="bodyMRegular">
            {t(
              'Los clientes podrán utilizarlo introduciéndolo en el carrito en el momento de la compra, igual que cualquier otro tipo de código de descuento.'
            )}
          </Text>
          <Text type="bodyMRegular">
            {t(
              'El código es de un solo uso, no acumulable y de uso exclusivo por el cliente que solicitó el reembolso.'
            )}
          </Text>
        </>
      )}
      {refundMethodType === refundMethods.originalPaymentMethod && (
        <>
          <Text type="bodyMRegular">
            {t(
              'Cuando los clientes elijan este método de reembolso recibirán su dinero en el mismo método de pago que utilizaron para hacer su compra original.'
            )}
          </Text>
          <Text type="bodyMRegular">
            {t(
              'Dependiendo del método de pago que usaran, una vez emitido el reembolso pueden tardar minutos, horas o incluso días en recibir su dinero.'
            )}
          </Text>
        </>
      )}
      {refundMethodType === refundMethods.giftCard && (
        <>
          <Text type="bodyMRegular">
            {t(
              'Cuando los clientes elijan este método de reembolso se generará un código de tarjeta regalo que se les enviará por email en el momento de la emisión.'
            )}
          </Text>
          <Text type="bodyMRegular">
            {t('Los clientes podrán utilizarlo introduciéndolo como método de pago en el momento de la compra.')}
          </Text>
        </>
      )}
    </Styles.Container>
  )
}
export default DescriptionMessage
